/**
 * Page-level setters for the Cashflow Management orchestrator.
 *
 * Owns only orchestrator-scoped setters still used by the controller.
 * Tab and period mutations happen inline in `treasury.controller.js`
 * handlers via `setState` (same pattern as `billing.delegate.js`).
 *
 * Behavioural callbacks that React passes around as props (`handleTabChange`,
 * etc.) live on the controller class itself as arrow class fields — placing
 * them here would break their `this` binding because `Inherit` copies mixin
 * instance fields from a throwaway instance, capturing the wrong lexical
 * `this`.
 *
 * Mixed into the React component via `Inherit(ClockoutController,
 * TreasuryDelegate)`, so `this` inside these methods resolves to the React
 * component instance.
 */
class TreasuryDelegate {
    setLoading(loading) {
        this.setState({ loading: !!loading });
    }
}

export default TreasuryDelegate;
